// client/src/routes/_auth/mfa.tsx — SCR-AUTH-003 „Verificare MFA" · AUTH-004.
//
// Reachable only from a login that stopped at the second factor. The pending challenge lives
// in memory (the token itself is an HttpOnly cookie, 02 §6.5); a reload of this page has no
// challenge to render and goes back to the password — see DEVIATIONS D-186.

import { createFileRoute, redirect } from '@tanstack/react-router';

import { MfaChallenge } from '@/features/auth/MfaChallenge';
import { forwardRedirect, landingFor, redirectSearchSchema, safeRedirect } from '@/features/auth/redirect';
import { ensureSession } from '@/session';
import { useAuthStore } from '@/stores/auth-store';

export const Route = createFileRoute('/_auth/mfa')({
  validateSearch: redirectSearchSchema,
  beforeLoad: async ({ search }) => {
    const session = await ensureSession();
    if (session) throw redirect({ href: safeRedirect(search.redirect, landingFor(session)) });

    const pending = useAuthStore.getState().pendingMfa;
    if (!pending) throw redirect({ to: '/login', search: forwardRedirect(search) });
    if (pending.enrollmentRequired) throw redirect({ to: '/mfa/enroll', search: forwardRedirect(search) });
  },
  component: MfaScreen,
});

function MfaScreen() {
  const search = Route.useSearch();
  return <MfaChallenge search={search} />;
}
